export default "__VITE_PUBLIC_ASSET__c4a54fdc__"